import groq from 'groq';

import { BACKGROUND } from './background';
import { CLOUDINARY_VIDEO } from './cloudinaryVideo';
import { CONSENT_CAPTURE } from './consentCapture';
import { DATE_RANGE } from './dateRange';
import { OVERLINE } from './overline';

export const PROMO_HERO = groq`
  "heroType": coalesce(heroType, "promotion"),
  hero {
    title,
    media[0]{
      _type,
      _type == 'background' => {
        ${BACKGROUND}
      },
      _type == 'video' => {
        ${CLOUDINARY_VIDEO}
      },
    },
    subtitle,
    ${OVERLINE},
    "isDoctorRecommended": coalesce(isDoctorRecommended, false),
    text,
    bulletPoints,
    cta {
      type,
      ${CONSENT_CAPTURE},
      link {
        href,
        title,
      },
      klaviyoListId,
    },
    dateRange[0] { ${DATE_RANGE} },
    "isForceWhiteText": coalesce(isForceWhiteText, false)
  }
`;
